import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output
} from '@angular/core';
import { ProductModel } from '../models/product.model';
import { ModelModel } from '../models/model.model';
import { TableRowModel } from '../models/tablerow.model';
import { ProdcutImageUtil } from '../../lib/product-image-util';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-model-details-details',
  template: `
<div>
  <div style="display: flex; align-items: center;">
   <div>
     <h1 [id]="'models_number_header_' + this.displayData" class="modelsNumber">{{model.modelNumber}}</h1>
     <div *ngIf="this.isSystemModel()" class="systemModel">{{model.lgModelNo}}</div>
  <div *ngIf="product" class="productName">{{product.title}}</div>
  <div *ngIf="product" class="productFamily">{{product.type}}</div>
  </div>
   <img *ngIf="showR32" src="angular/dist/assets/R32.png" style="width: 200px; height: 200px; margin-top: -40px;
    margin-left: -20px;">
	 </div>
  <div class="energy-star-logos" *ngIf="eneryStarLogos && eneryStarLogos.length > 0">
    <div *ngFor="let eneryStarLogo of eneryStarLogos">
      <img [src]="eneryStarLogo.Image" [alt]="eneryStarLogo.Title" *ngIf="shouldEnergyStarLogoImageShow(eneryStarLogo)"/>
    </div>
  </div>
  <div class="includesHeaderSpec">Specifications</div>
  <table class="table">
    <tbody>
      <tr *ngFor="let data of tableRows" class="specRow">
        <td class="specName">{{data?.firstcell}}</td>
        <td [ngClass]="this.getClass(data?.secondcell)">{{data?.secondcell}}</td>
      </tr>
    </tbody>
  </table>

  <div style="width:100%;text-align:center;">
    <button [attr.aria-describedby]="'models_number_header_' + this.displayData" class="viewMoreButton" (click)="viewMore()" [hidden]="this.toggleMoreToViewButtonDisable">{{viewMoreText}}</button>
  </div>
</div>
  `,
  styles: [
    `
      .productName {
        color: #4a4a4a;
        font-family: 'LGEIRegular';
        font-size: 32px;
        text-align: left;
      }

      .productFamily {
        color: #4a4a4a;
        font-family: 'LGEILight';
        font-size: 20.1px;
        text-align: left;
      }

      .modelsNumber {
        color: #a50034;
        font-family: 'LGEIBold';
        font-size: 40px;
        text-align: left;
      }

      .downloadLink {
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 20.1px;
        text-align: left;
        margin-bottom: 5px;
      }

      .includesHeader {
        color: #a50034;
        font-family: 'LGEIBold';
        font-size: 28px;
        text-align: left;
      }

      .includesHeaderSpec {
        color: #a50034;
        font-family: 'LGEIBold';
        font-size: 28px;
        text-align: left;
        border-bottom: #a50034 3px solid;
      }

      .includeProduct {
        color: #4a4a4a;
        font-family: 'LGEILight';
        font-size: 16px;
        text-align: left;
      }

      .specName {
        color: #4a4a4a;
        font-family: 'LGEILight';
        font-size: 16px;
        text-align: left;
      }

      .specValueProduct {
        color: #a50034;
        font-family: 'LGEILight';
        font-size: 16px;
        text-align: right;
      }

      .specRow {
        border-bottom: #d1d1d2 2px solid;
      }

      .specValue {
        color: #4a4a4a;
        font-family: 'LGEIBold';
        font-size: 16px;
        text-align: right;
      }

      .systemModel {
        color: #4a4a4a;
        font-family: 'LGEIBold';
        font-size: 16px;
        text-align: left;
        margin-top: -10px;
      }

      .specValueNull {
        color: #d1d1d2;
        font-family: 'LGEIBold';
        font-size: 16px;
        text-align: right;
      }

      .viewMoreButton {
        border: 1px solid #a50034;
        border-radius: 4px;
        background-color: #ffffff;
        color: #a50034;
        font-family: 'LGEILight';
        font-size: 16px;
        line-height: 2;
        text-align: center;
        width: 150px;
        cursor: pointer;
      }

      .energy-star-logos {
        height: 80px;
        display: flex;
        margin-top: 30px;
        margin-bottom: 64px;
      }

      .energy-star-logos img {
        max-height: 100%!important;
        margin-right: 20px;
      }
    `
  ]
})
export class ModelDetailsDetailsComponent implements OnChanges {
  @Input() model: ModelModel;
  @Input() product: ProductModel;
  @Input() eneryStarLogos: { Title: string, Image: string }[];
  @Input() displayData: string;
  certifications: string[] = [];
  tableRows: TableRowModel[] = [];
  viewMoreToggle: Boolean = true;
  viewMoreText = 'View More';
  toggleMoreToViewButtonDisable: boolean;
  archiveUrl: string;
  showR32: boolean = false;

  ngOnChanges() {
    if (this.model && this.model.ahriInformation && this.model.ahriInformation.length > 0) {
      // extract unique certifications from all AHRI information associated with the model
      let certificationsDeep = this.model.ahriInformation.map(i => i.certifications);
      let certificationsFlat = certificationsDeep.reduce((a, b) => a.concat(b));
      this.certifications = certificationsFlat.filter((val, idx, arr) => {
        return arr.indexOf(val) === idx;
      });
    }

    this.archiveUrl = `${environment.archivePath}/resource_archive_${this.model.id}.zip`;
    // find all values that exist to have a count
    if (this.model && this.model.attributes) {
      const filteredValues = this.model.attributes.filter(x => x.value !== '');

      for (let i = 0; i < this.model.attributes.length; i++) {
        if (this.model.attributes[i].value) {
          if (filteredValues.length < 6) {
            this.toggleMoreToViewButtonDisable = true;
            const newRow: TableRowModel = new TableRowModel();
            newRow.firstcell = this.model.attributes[i].name;
            newRow.secondcell = this.model.attributes[i].value
              ? this.model.attributes[i].value
              : 'N/A';

            this.tableRows.push(newRow);
            if (this.model.attributes[i].name == 'Refrigerant Type' && this.model.attributes[i].value == 'R32') {
              this.showR32 = true;
            }
          } else {
            this.toggleMoreToViewButtonDisable = false;
            if (i < 6) {
              this.toggleMoreToViewButtonDisable = true;
              const newRow: TableRowModel = new TableRowModel();
              newRow.firstcell = this.model.attributes[i].name;
              newRow.secondcell = this.model.attributes[i].value
                ? this.model.attributes[i].value
                : 'N/A';

              this.tableRows.push(newRow);
              if (this.model.attributes[i].name == 'Refrigerant Type' && this.model.attributes[i].value == 'R32') {
                this.showR32 = true;
              }
            }
          }
        }
      }
    }
  }

  viewMore() {
    this.tableRows = [];
    if (this.viewMoreToggle === true) {
      for (let i = 0; i < this.model.attributes.length; i++) {
        if (this.model.attributes[i].value) {
          const newRow: TableRowModel = new TableRowModel();
          newRow.firstcell = this.model.attributes[i].name;
          newRow.secondcell = this.model.attributes[i].value;

          this.tableRows.push(newRow);
          if (this.model.attributes[i].name == 'Refrigerant Type' && this.model.attributes[i].value == 'R32') {
            this.showR32 = true;
          }
        }
      }
      this.viewMoreToggle = false;
      this.viewMoreText = 'View Less';
    } else {
      for (let i = 0; i < this.model.attributes.length; i++) {
        if (i < 6) {
          if (this.model.attributes[i].value) {
            const newRow: TableRowModel = new TableRowModel();
            newRow.firstcell = this.model.attributes[i].name;
            newRow.secondcell = this.model.attributes[i].value;

            this.tableRows.push(newRow);
            if (this.model.attributes[i].name == 'Refrigerant Type' && this.model.attributes[i].value == 'R32') {
              this.showR32 = true;
            }
          }
        }
      }
      this.viewMoreToggle = true;
      this.viewMoreText = 'View More';
    }
  }

  shouldEnergyStarLogoImageShow(energyStarLogoObject: { Title: string, Image: string }) {
    if (!this.certifications || this.certifications.length <= 0) {
      return false;
    }

    return !this.isAnyEmptyOrWhiteSpace(energyStarLogoObject.Title, energyStarLogoObject.Image) &&
      this.certifications.some(x => x.trim() == energyStarLogoObject.Title.trim());
  }

  getClass(data: string): string {
    if (data === 'N/A') {
      return 'specValueNull';
    } else {
      return 'specValue';
    }
  }

  isSystemModel(): boolean {
    return this.model.modelType && this.model.modelType.toLowerCase() === 'system model';
  }

  isEmptyOrWhiteSpace(str: string) {
    return str == null || str == undefined || str.trim() == '';
  }

  isAnyEmptyOrWhiteSpace(...str: string[]): boolean {
    return str.some(x => this.isEmptyOrWhiteSpace(x));
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/model-details-details.component.ts